import React from "react";
import { cn } from "../../lib/cn";

export interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  maxWidth?: number | string;
  className?: string;
}

/** claudesign search field. Mirrors `.search` / `.search .go` /
 *  `.search:focus-within` from docs/redesign/ommuse-theme.css. */
export const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder = "Search...",
  maxWidth = 380,
  className,
}) => (
  <div
    style={{ maxWidth }}
    className={cn(
      "flex items-center gap-[10px] flex-1 bg-surface-2 border border-border rounded-[30px]",
      "pl-[18px] pr-[8px] py-[7px] shadow-edge-hi",
      "transition-[border-color,box-shadow] duration-150",
      "focus-within:border-[color-mix(in_oklab,var(--cyan)_55%,var(--border))]",
      "focus-within:shadow-[0_0_0_3px_var(--accent-soft),var(--edge-hi)]",
      "focus-within:outline focus-within:outline-2 focus-within:outline-[var(--cyan)] focus-within:outline-offset-2",
      className,
    )}
  >
    <svg viewBox="0 0 24 24" aria-hidden className="w-[18px] h-[18px] shrink-0 text-cyan fill-current">
      <path d="M12 2l1.6 4.4L18 8l-4.4 1.6L12 14l-1.6-4.4L6 8l4.4-1.6L12 2z" />
    </svg>
    <input
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") onSubmit?.();
      }}
      className={cn(
        "flex-1 min-w-0 bg-transparent border-none outline-none",
        "text-body font-sans text-[14px] placeholder:text-muted",
      )}
    />
    <button
      type="button"
      onClick={() => onSubmit?.()}
      className={cn(
        "bg-accent-grad text-cyan-ink border-0 font-sans font-semibold text-[14px]",
        "px-[18px] py-[9px] rounded-[24px] cursor-pointer",
        "shadow-[var(--glow),inset_0_1px_0_rgba(255,255,255,.28)]",
        "transition-[filter,box-shadow] duration-150 hover:brightness-[1.07] hover:shadow-glow-strong",
      )}
    >
      Search
    </button>
  </div>
);

export default SearchField;
